import Rails from '@rails/ujs';

document.addEventListener('turbolinks:load', () => {
  // only run the following on specific pages
  const elements = document.querySelectorAll('body.home.index, body.categories.show');
  elements.forEach((el) => {
    if (navigator.geolocation)  {
      navigator.geolocation.getCurrentPosition(function (position) {
        Rails.ajax({
          type: "GET",
          url: "/reverse_geocode?latitude=" + position.coords.latitude + "&longitude=" + position.coords.longitude,
          success: function (response) {
            if(response) {
              if (document.querySelector('.to-change') != null) {
                var img = document.querySelector('.to-change')
                if (response.image) img.src = response.image
                img.classList.add('opaque')
              }
            }

          },
          error: function (response) { }
        });
      })
    };

    // some stuff we need to limit only if the hero element exists

    const hero = el.querySelector('.hero');

    if (hero) {
      const closeButtons = el.querySelectorAll('.close-icon');
      const verticalLink = el.querySelector('.vertical-link');
      const allCategories = el.querySelector('.all-categories');
      const tabsPanel = el.querySelectorAll('.tabs-panel');

      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', (evt) => {
          clearActiveTabs();
          closeButton.classList.remove('hide')
          hero.classList.remove('hide');
        })
      })

      verticalLink && verticalLink.addEventListener('click', (evt) => {
        clearActiveTabs();
        hero.classList.remove('hide');
      })

      allCategories && allCategories.addEventListener('click', (evt) => {
        tabsPanel.forEach((tab) => { tab.classList.add('is-active') })
        hideAllCloseButtons(closeButtons);
        closeButtons[0].classList.remove('hide');
        hero.classList.add('hide');
      })
    }
  })
  setInterval(function(){
    let tabs = document.querySelectorAll('.tabs-title.big-slider')
    let tab = document.querySelector('.tabs-title.big-slider.is-active')
    if(tabs && tab) {
      if(tab && tab.nextSibling != null){
        tab.nextSibling.click()
      }
      else{
        tabs[0].click()
      }
    }
  }, 10000);
});

const clearActiveTabs = () => {
  const activeTabs = document.querySelectorAll('.tabs-panel.is-active');
  activeTabs.forEach((active) => { active.classList.remove('is-active') });
}

const hideAllCloseButtons = (allButtons) => {
  allButtons.forEach((button) => {
    button.classList.add('hide')
  })
}
